import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { RedTriangleCaution } from '@components/RedTriangleCaution';
import { Button, Flex, Text } from '@endurancewarranty/ui';
import type { FC } from 'react';
type Props = {
  onClose: () => void;
};
export const RewriteNotAllowedModal: FC<Props> = t0 => {
  const $ = _c(4);
  const {
    onClose
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Flex justify="center"><RedTriangleCaution className="h-14 w-14" /></Flex>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mt-4"><Text.Body size="lg" fontWeight="bold" align="center">Rewrite Not Allowed</Text.Body><Text.Body align="center" margin="mt-1" wordBreak="break-word" whitespace="normal">Cannot rewrite coverage unless changes requiring a Rewrite are made.</Text.Body></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onClose) {
    t3 = <Flex direction="col" className="h-42" justify="between">{t1}{t2}<Flex justify="end" className="mt-4"><Button name="invalid-address-modal-okay" variant="primary" width="fit" onClick={onClose}>Okay</Button></Flex></Flex>;
    $[2] = onClose;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};